import { AUTOMATION_RULES_CREATE_ACTION_ID, automationRulesCreateDefinition } from './automation-rules-action';
import { PACKING_SLIP_UPDATE_ACTION_ID, packingSlipUpdateDefinition } from './packing-slip-action';
import type { ActionDefinition } from '../types';

export { AUTOMATION_RULES_CREATE_ACTION_ID } from './automation-rules-action';
export { PACKING_SLIP_UPDATE_ACTION_ID } from './packing-slip-action';

export const allGlobalDefinitions: Array<{ id: string; definition: ActionDefinition }> = [
  { id: AUTOMATION_RULES_CREATE_ACTION_ID, definition: automationRulesCreateDefinition },
  { id: PACKING_SLIP_UPDATE_ACTION_ID, definition: packingSlipUpdateDefinition },
];
